module.exports = __webpack_public_path__ + "static/img/beGenerativeLogo.d8d520a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/beGenerativeLogo.png
// module id = 57mU
// module chunks = 1